// src/router/index.js
import Vue from 'vue';
import Router from 'vue-router';
import HomePage from '@/components/HomePage.vue';
// import About from '@/components/About.vue';
// import ContactInfo from '@/components/ContactInfo.vue';

Vue.use(Router);

export default new Router({
  mode: 'history', // 你可以根据需要选择 'hash' 或 'history' 模式
  routes: [
    {
      path: '/home',
      name: 'HomePage',
      component: HomePage
    },
    {
      path: '/',
      name: 'HomePage',
      component: HomePage
    },
    {
      path: '*',
      
      redirect: '/'
    }
    // {
    //   path: '/about',
    //   name: 'About',
    //   component: About
    // },
    // {
    //   path: '/contactinfo',
    //   name: 'ContactInfo',
    //   component: ContactInfo
    // },
    // 你可以在这里添加更多的路由配置
  ]
});